var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 17,
    viewBox: "0 0 16 17",
    width: 16,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m12.6693 2.5h-9.33336c-1.10457 0-2 .89543-2 2v9.3333c0 1.1046.89543 2 2 2h9.33336c1.1045 0 2-.8954 2-2v-9.3333c0-1.10457-.8955-2-2-2zm-10.00369 1.99918c0-.36819.29848-.66667.66667-.66667h9.33332c.3682 0 .6667.29848.6667.66667v9.33332c0 .3682-.2985.6667-.6667.6667h-9.33332c-.36819 0-.66667-.2985-.66667-.6667z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.00163 7.83333c-.36819 0-.66667-.29847-.66667-.66666s.29848-.66667.66667-.66667h11.99997c.3682 0 .6667.29848.6667.66667s-.2985.66666-.6667.66666z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.0049 1.83464c0-.36819.2985-.66667.6666-.66667.3682 0 .6667.29848.6667.66667v2.66666c0 .36819-.2985.66667-.6667.66667-.3681 0-.6666-.29848-.6666-.66667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.66455 1.83464c0-.36819.29848-.66667.66667-.66667s.66666.29848.66666.66667v2.66666c0 .36819-.29847.66667-.66666.66667s-.66667-.29848-.66667-.66667z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.66c2488c.svg";
export { ForwardRef as ReactComponent };